// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3zB0b","search":"Settings_search__1JHen","filter":"Settings_filter__hS9X4"};